import React from 'react';

export default (_props) => {
  const { className, size, large, small, ...props } = _props;

  // small icon
  if ((size && size.toLowerCase() === 'small') || small) {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={`audiicon audiicon-small ${className ? className : ''}`} {...props}>
        <path d="M7.80005 11.8L11.1 15.1L16.2 7.90002M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z" stroke="#0DA20D" />
      </svg>
    );
  }

  // large icon
  return (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={`audiicon audiicon-large ${className ? className : ''}`} {...props}>
      <path d="M7.80005 11.8L11.1 15.1L16.2 7.90002M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z" stroke="#0DA20D" />
    </svg>
  );
};


